export default __webpack_public_path__ + "img/cbShtAbb.78c3127a.svg";